module.exports = __webpack_public_path__ + "static/media/downloadlogoone.5ed14f56.png";